angular.module('unica_dashboard.dashboard_controllers', [])

.controller('DashboardController', function( $rootScope ) {

    if ( !$rootScope.year ) {
        $rootScope.year = 2020;
    }

});